const listTab = [
    {
      name:"Studio",
      tab:['images/extrait1','images/extrait3','images/extrait4','images/extrait5',"images/studio21","images/studio22","images/studio23","images/studio1","images/studio5","images/studio7","images/studio9"
     ,"images/studio11","images/studio12","images/studio16","images/studio17","images/studio20"]
    },
    {
      name:"Mariage",
      tab:["images/Mariage3","images/Mariage4","images/Mariage6","images/Mariage9",
      "images/Mariage10","images/Mariage11","images/Mariage15","images/Mariage16","images/Mariage17","images/Mariage18","images/Mariage19",
      "images/Mariage21", "images/Mariage23", "images/Mariage24" ]
    },
    {
      name:"Bapteme",
      tab:["images/Bapteme1","images/Bapteme2","images/Bapteme4","images/Bapteme6","images/Bapteme7","images/Bapteme8",
      "images/Bapteme10","images/Bapteme11", "images/Bapteme12","images/Bapteme13","images/Bapteme14","images/Bapteme16","images/Bapteme17",
      "images/Bapteme21", "images/Bapteme25","images/Bapteme27", "images/Bapteme28" ]
    },
    {
      name:"A Domicile",
      tab:["images/Domicile1","images/Domicile2","images/Domicile5","images/Domicile6","images/Domicile7","images/Domicile8","images/Domicile9",
      "images/Domicile10","images/Domicile11", "images/Domicile12","images/Domicile13","images/Domicile14","images/Domicile15",
      "images/Domicile21", "images/Domicile22", "images/Domicile23", "images/Domicile24", "images/Domicile25" ]
    },
    {
      name:"Exterieur",
      tab:["images/Exterieur1","images/Exterieur2","images/Exterieur3","images/Exterieur6","images/Exterieur8",
    "images/Exterieur11","images/Exterieur16","images/Exterieur17","images/Exterieur18",
      "images/Exterieur21", "images/Exterieur22", "images/Exterieur24" ]
    }
  ];

  module.exports = listTab;